//MyKaizenSMART
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal } from '@fortawesome/free-solid-svg-icons';
import './MyKaizen.css';
import KaizenSmartImage from '../../assets/pageimages/MyKaizenSMART.webp';


function MyKaizenSMART() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>MyKaizen - SMART</h2>
      </div>
      <div className="main-content">
        <div className="flex justify-center mt-2 mb-2">
          <img className="align-middle" src={KaizenSmartImage} alt="Ad" />
        </div>
      </div>
    </MainLayout>
  );
}

export default MyKaizenSMART;